import { Col, Dropdown } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  getInitialLettersUser,
  getNameResume,
  getNomeUsuarioAlternado,
} from '../../helpers/user';
import { AuthConsumer } from '../../security/authContext';
import {
  AvatarGreetingUser,
  ColDescription,
  ContainerGreetingUser,
  CustomButton,
  ExportOutlinedCustom,
  MenuCustom,
  NameGreetingImpersonatedUser,
  NameGreetingUser,
  UserOutlinedCustom,
} from './styles';

const GreetingUser = ({ name, nomeAlternado }) => {
  const history = useHistory();

  const acessarPerfil = () => {
    history.push('/perfil');
  };

  const menu = (
    <MenuCustom data-testid="menu-logout">
      <MenuCustom.Item>
        <CustomButton type="link" onClick={() => acessarPerfil()}>
          <UserOutlinedCustom />
          Perfil
        </CustomButton>
      </MenuCustom.Item>
      <MenuCustom.Item>
        <AuthConsumer>
          {({ logout }) => (
            <CustomButton type="link" onClick={() => logout(history)}>
              <ExportOutlinedCustom />
              Sair
            </CustomButton>
          )}
        </AuthConsumer>
      </MenuCustom.Item>
    </MenuCustom>
  );

  return (
    <ContainerGreetingUser>
      <ColDescription data-testid="greeting-user-description">
        <NameGreetingUser data-testid="name-greeting-user">
          {`Olá, ${getNameResume(name)}`}
        </NameGreetingUser>
        {nomeAlternado !== 'undefined' && (
          <NameGreetingImpersonatedUser data-testid="name-greeting-impersonated-user">
            {`Você está no perfil: ${getNomeUsuarioAlternado(nomeAlternado)}`}
          </NameGreetingImpersonatedUser>
        )}
      </ColDescription>
      <Col>
        <Dropdown overlay={menu} placement="bottomRight">
          <AvatarGreetingUser
            data-testid="greeting-user-avatar"
            alt="avatar do usuário"
          >
            {getInitialLettersUser(name)}
          </AvatarGreetingUser>
        </Dropdown>
      </Col>
    </ContainerGreetingUser>
  );
};

GreetingUser.propTypes = {
  name: PropTypes.string,
  nomeAlternado: PropTypes.string,
};

GreetingUser.defaultProps = {
  name: 'Carregando...',
  nomeAlternado: null,
};

export default GreetingUser;
